import React from 'react';
import PropTypes from 'prop-types';
import Locale from '../locales/en/about';
import CloseIcon from '../images/x-close.svg';

const About = ({ isVisible, toggle }) => (
  <div
    id="about"
    className={isVisible ? 'show' : ''}
  >
    <button type="button" className="close-button" onClick={toggle}>
      <img src={CloseIcon} alt="close" />
    </button>
    <div className="about-content-wrapper">
      <div className="about-header">
        <h3>
          {Locale.header}
        </h3>
      </div>
      <div
        className="text-box"
        dangerouslySetInnerHTML={{ __html: Locale.body }}
      />
    </div>
  </div>
);

About.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired
};

export default About;
